import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service for sharing tree search state across components
 */
@Injectable({
  providedIn: 'root'
})
export class TreeSearchService {
  private searchTextSubject = new BehaviorSubject<string>('');
  
  // Observable that components can subscribe to
  searchText$: Observable<string> = this.searchTextSubject.asObservable();
  
  constructor() { }
  
  /**
   * Update the shared search text
   * @param searchText The search text to share
   */
  updateSearchText(searchText: string): void {
    this.searchTextSubject.next(searchText);
  }
  
  /**
   * Get the current search text value
   */
  getCurrentSearchText(): string {
    return this.searchTextSubject.getValue();
  }
} 